import { useRouter } from 'next/router';
import { useEffect, useMemo } from 'react';

import { useToggle } from './useToggle';

import { SiteMenuItem } from '@/types';

interface IUseSidebarMenu {
  currentPageSlug: string;
  menuItem: SiteMenuItem | null;
  showMenu: boolean;
  handleToggleMenu: () => void;
}

export const useSidebarMenu = (siteMenu: SiteMenuItem[]): IUseSidebarMenu => {
  const router = useRouter();
  const [showMenu, handleToggleMenu, setShowMenu] = useToggle();

  const currentPageSlug = useMemo<string>(() => {
    const { query, pathname } = router;

    // page slug for [type] pages
    if ('type' in query && typeof query.type === 'string') {
      return query.type;
    }

    // page slug for other pages without hash
    const pathArr = pathname.split('/');

    return pathArr[pathArr.length - 1];
  }, [router]);
  const menuItem = useMemo<SiteMenuItem | null>(
    () => siteMenu.find(({ dropdown }) => dropdown.find(({ page_slug }) => page_slug === currentPageSlug)) ?? null,
    [currentPageSlug, siteMenu],
  );

  // closes sidebar menu if route was changed by main menu
  useEffect(() => {
    setShowMenu(false);
  }, [setShowMenu, router.asPath]);

  return { currentPageSlug, menuItem, showMenu, handleToggleMenu };
};
